import * as React from 'react';
import { MainBody } from '../../layout/body/Body';
import { Greetings } from '../../components/authentication/greetings';

interface Props {
  children?: React.ReactNode
}

export const StandardPage = (props: Props) => {
  const { children } = props;
  return (
    <Greetings worldAware={true}>
      <MainBody>
        {children}
      </MainBody>
    </Greetings>
  );
};
